import { createStyles, makeStyles } from '@material-ui/core'

export const useHeaderTabsStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        height: '100%',

        '& div': {
          height: '100%'
        }
      },

      indicator: {
        height: 3
      },

      tab: {
        minWidth: 110,
        marginRight: 55,
        paddingLeft: 0,
        paddingRight: 0,
        fontSize: 20,
        fontWeight: 400,
        textTransform: 'initial',
        color: theme.palette.text.primary,
        opacity: 1,

        '&:last-child': {
          marginRight: 0
        }
      },

      selected: {
        color: theme.palette.primary.main,
        fontWeight: 600
      },

      notification: {
        overflow: 'visible',

        '& span': {
          position: 'relative',

          '&::after': {
            content: '""',
            position: 'absolute',
            left: -7,
            top: 5,
            width: 6,
            height: 6,
            backgroundColor: theme.palette.warning.main,
            borderRadius: '50%'
          }
        }
      }
    }),
  {
    name: 'HeaderTabs'
  }
)
